export default __webpack_public_path__ + "media/images/portfolio/gallery-09-390x230-9d77e15863ac0212ba3bfafd0c4d18cc.jpg";